import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import AvatarLogo from "../../../../../images/theme/avatar/logo-horizontal-dark.png";
import Modal from "../../../../../components/modal-fullscreen";
import styled from "styled-components";
import moment from "moment";

// Create styles
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  image: {
    width: 140,
  },
  sectionHeader: {
    backgroundColor: "#000000",
    color: '#FFFFFF',
    fontSize: 10,
    padding: 4,
    marginBottom: 8,
    fontWeight: 700,
    width: '50%',
    // fontFamily: "Oswald",
  },
  dataRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 6,
  },
  dataName: {
    color: "#444",
    fontSize: 12,
    width: 100,
  },
  dataValue: {
    fontSize: 12,
  },
  billingRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 6,
  },
  billingValue: {
    marginVertical: 1,
    fontSize: 12,
  },
  text: {
    color: "#444",
    fontSize: 12,
    marginTop: 12,
    // fontFamily: "Times-Roman",
  },
  spacer: {
    height: 16,
  },
});

Font.register({
  family: "Oswald",
  src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
});

// Create Document Component
export const Invoice = ({ transaction }) => {
  return (
    <Document>
      <Page style={styles.body}>
        <Image style={styles.image} src={AvatarLogo} />
        <View style={styles.spacer} />
        <View style={styles.spacer} />
        <Text style={styles.sectionHeader}>ORDER DETAILS</Text>
        <View style={styles.dataRow}>
          <Text style={styles.dataName}>Invoice #</Text>
          <Text style={styles.dataValue}>{transaction.paymentId}</Text>
        </View>
        <View style={styles.dataRow}>
          <Text style={styles.dataName}>Date</Text>
          <Text style={styles.dataValue}>
            {moment.utc(transaction.createdAt).format("MMMM D, YYYY")}
          </Text>
        </View>
        <View style={styles.dataRow}>
          <Text style={styles.dataName}>Transaction ID</Text>
          <Text style={styles.dataValue}>{transaction.id}</Text>
        </View>
        <View style={styles.dataRow}>
          <Text style={styles.dataName}>Amount billed</Text>
          <Text style={styles.dataValue}>${transaction.amount}</Text>
        </View>
        {transaction?.billing?.streetAddress && (
          <>
            <View style={styles.spacer} />
            <Text style={styles.sectionHeader}>BILL TO</Text>
            <Text style={styles.billingValue}>
              {transaction.billing.firstName} {transaction.billing.lastName}
            </Text>
            <Text style={styles.billingValue}>
              {transaction.billing.company}
            </Text>
            <Text style={styles.billingValue}>
              {transaction.billing.streetAddress}
            </Text>
            <Text style={styles.billingValue}>
              {transaction.billing.extendedAddress}
            </Text>
            <Text style={styles.billingValue}>
              {transaction.billing.locality}, {transaction.billing.region}{" "}
              {transaction.billing.postalCode}
            </Text>
            <Text style={styles.billingValue}>
              {transaction.billing.countryName}
            </Text>
          </>
        )}
        <View style={styles.spacer} />
        <Text style={styles.text}>
          Avatar Nutrition will generate a charge based on the billing rate of
          each covered user and the number of covered users associated with your
          account. Charges will be incurred monthly on the billing date renewal
          (which is every thirty days from the account creation).
        </Text>
      </Page>
    </Document>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;

  iframe {
    border: none;
    flex: 1;
    height: 100%;
    width: 100%;
  }
`;

export const PreviewDocument = ({ open, handleClose, transaction }) => {
  return (
    <>
      <Modal
        hideAction
        // fullScreen
        title={`Preview Invoice`}
        submitLabel={`Close`}
        open={open}
        onClose={() => handleClose(false)}
        // handleSubmit={handleSend}
      >
        <Container>
          <PDFViewer>
            <Invoice transaction={transaction} />
          </PDFViewer>
        </Container>
      </Modal>
    </>
  );
};
